import { GET_PLAN } from "../reducers/keys";
import { CHECK_STRIPE_SESSION, GET_PLAN_API, GET_STRIPE_URL, sendPayLink, STRIPE_SUCCESS_CALLBACK, stripeRecurrApi } from "./api";
import { Cookies } from "react-cookie";
import HttpClient from "./http-client";
import { toast } from "react-toastify";
import { getUseronboardingInfo } from "./loginActions";
import { closePricingModal } from "../utils/close_modal";
import { getAllNotification } from "./notificationAction";

const cookies = new Cookies();

export function getProductAndPlanDetails() {
    return async (dispatch) => {
        let googleFeedCookies = cookies.get('googleBlogUser');
        let postObj = {};
        if(googleFeedCookies && Object.keys(googleFeedCookies).length > 0){
            postObj = googleFeedCookies;
        }
        await new HttpClient().post(GET_PLAN_API,{...postObj, feedbackMail : (postObj && Object.keys(postObj).length > 0) ? 1 : 0}).then((response) => {
            const { responseData,plan54expirationDate,plan54activationDate } = response.data;
            if (responseData && Object.keys(responseData).length > 0) {
                dispatch({ type: GET_PLAN, payload: { planList: responseData, startDate: plan54activationDate, endDate: plan54expirationDate } });
            }
        }).catch((ex) => {})
    }
}

export const getPlan = (postBody, callback) => {
    const toastID = toast.loading("Loading...");
    new HttpClient().post(GET_STRIPE_URL, postBody).then((res) => {
        const { responseCode, responseData } = res.data;
        if (responseCode == 200 && Object.keys(responseData ?? {})?.length > 0) {
            const { referenceId, url, requestData } = responseData;
            localStorage.setItem("referenceId", referenceId);
            if (requestData && requestData?.hasOwnProperty('subscriptionUpdatedStatus') && callback) {
                setTimeout(() => toast.dismiss(toastID), 3000);
                callback({ ...requestData, url });
            } else window.location.href = url;
        }
    }).catch(ex => {
        if (callback) callback();
        catchMethod(toastID, ex);
    });
}


export const recurringApi = (postBody) => new HttpClient().post(stripeRecurrApi, { ...postBody, isAdmin: localStorage.getItem('adminId') ? true : false });

export const checkStripSession = (payload) => {
    return new HttpClient().post(CHECK_STRIPE_SESSION, { 
        ...payload, 
        adminId: localStorage.getItem('adminId') ?? localStorage.getItem('ownerId') 
    });
}

export const successCallback = (referenceId) => {
    return new HttpClient().post(STRIPE_SUCCESS_CALLBACK, {
        referenceId,
        adminId: localStorage.getItem('adminId') ?? localStorage.getItem('ownerId'),
    });
}

export const getRecurringDetails = (postBody, setData) => {
    const toastID = toast.loading("Loading...");
    recurringApi(postBody).then((res) => {
        const { responseCode, responseData } = res.data;
        if (responseCode == 200 && Object.keys(responseData).length > 0) {
            setData(responseData);
            setTimeout(() => toast.dismiss(toastID), 200);
        }
    }).catch(ex => {
        catchMethod(toastID, ex);
        setData(null, ex?.response?.data?.responseData?.isCreatenewSubscription ? true : false);
    });
}

export const updateInvoice = (navigate) => {
    return (dispatch) => {
        const referenceId = localStorage.getItem("referenceId");
        if(referenceId){
            const toastID = toast.loading("Loading...");
            checkStripSession({ referenceId, sessionId: "", isProrated: true }).then((res) => {
                const { responseCode } = res.data;
                setTimeout(() => toast.dismiss(toastID), 200);
                if (responseCode == 200) {
                    localStorage.removeItem("referenceId");
                    dispatch(getUseronboardingInfo((isPlanExpire) => {
                        if (isPlanExpire) {
                            closePricingModal(dispatch);
                            localStorage.setItem('plan_exceeded', true);
                            navigate(`/widget/wall/extrawallfeeds`)
                        }
                        dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby: "message", direction: "ASC" }, true));
                        dispatch(getProductAndPlanDetails());
                    }, false));
                }
            }).catch(ex => {
                catchMethod(toastID, ex);
            });
        }
    }
}

export const sendPaymentByEmail =(emailId, url) => new HttpClient().post(sendPayLink, { emailId, url });

const catchMethod = (toastId, error) => {
    toast.update(toastId, { render: error?.response?.data?.responseMessage ?? "", type: toast.TYPE.ERROR, autoClose: 3000 });
    let timer = null;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => toast.dismiss(toastId), 3000);
}